import React, { useState } from "react";
import _ from "lodash";
import styles from "./ExternalTableFilters.module.scss"
import {ReactComponent as AddFilterIcon} from "./ic-table-add-external-filter.svg";
import {ReactComponent as UpArrowIcon} from "./ic-external-filter-up-arrow.svg";
import classNames from "classnames";
import { PopoverMechanism } from "../Popover";
import {chooseFilter} from "./InternalTableFilters"
import ClickAway from "../Functional/ClickAway";
import { Text, Button } from "../../"
import { CloseIcon } from "../../../icons/monochrome";

const ExternalColumnFilterButton = React.memo(({columnId, label, columnFilterOptions, columnFilterState = {activeCount: 0}, setColumnFilterInvisible, updateColumnFilter, filterConfig, filterClassName}) => {
    const [isOpen, setIsOpen] = useState(false);
    const count = columnFilterState.activeCount;
    const Filter = chooseFilter(filterConfig);

    const arrowStyle = isOpen ? {transform: "scaleY(-1)"} : undefined;

    return <div className={styles['external-column-filter-button']}>
        <button type="button" onClick={() => setIsOpen(true)} className={styles['open']}>{label}{count > 0 && ` (${count})`}<UpArrowIcon style={arrowStyle}/></button>
        <button type="button" onClick={() => {
            setColumnFilterInvisible({id: columnId});
            updateColumnFilter({});
        }} className={styles['close']}>
            <CloseIcon/>
        </button>
        {isOpen &&
            <>
                <ClickAway ignoreParentClick={true} listener={() => setIsOpen(false)}/>
                <Filter className={classNames(styles["external-filter"], filterClassName)} filterConfig={filterConfig} filterOptions={columnFilterOptions} filterState={columnFilterState} close={() => setIsOpen(false)} updateFilter={updateColumnFilter}/>
            </>
        }
    </div>
});

const SelectColumns = ({unfilteredColumns, setColumnFilterVisible}) => {
    return <div className={styles["select-columns-popover"]}>
            {unfilteredColumns.map(({id, header}) => {
                return <button type="button" key={id} onClick={() => setColumnFilterVisible({id})}>
                        {header}
                </button>
            })}
        </div>
};

const AddFilterTrigger = () => {
    return <AddFilterIcon/>
};

const AddFilterPopover = ({unfilteredColumns, setColumnFilterVisible}) => {
    return <PopoverMechanism
        Popover={SelectColumns}
        Trigger={AddFilterTrigger}
        popoverStyle={{transform: "translate(-35px, 11px)", transition: "none"}}
        triggerClassName={styles['add-filter']}
        triggerOnClick={true}
        setColumnFilterVisible={setColumnFilterVisible}
        unfilteredColumns={unfilteredColumns}
        disabled={unfilteredColumns.length === 0}
    />
};

export default React.memo(({filterOptions, filterState, updateFilterState, columns, style, className, resetFilters, filterClassName}) => {
    const [visibleFilters, setVisibleFilters] = useState({map: {}, array: []});
    const columnsMap = _.keyBy(columns, "id");

    const setColumnFilterVisible = ({id}) => {
        const array = visibleFilters.array.concat([id]);
        const map = {...visibleFilters.map, [id]: true};
        setVisibleFilters({map, array});
    };

    const setColumnFilterInvisible = ({id}) => {
        const array = _.pull(visibleFilters.array, id);
        const map = {...visibleFilters.map, [id]: false};
        setVisibleFilters({map, array});
    };

    const unfilteredColumns = _.filter(columns, column => {
        return filterOptions[column.id] && !visibleFilters.map[column.id]
    });

    return <div className={classNames(styles.base, className)} style={style}>
        <Text color="text-title">Filter By</Text>
        <div className={styles.filters}>
            {visibleFilters.array.map(columnId => {
                const updateColumnFilter = (values) => {
                    updateFilterState({
                        id: columnId,
                        values
                    });
                };

                return <ExternalColumnFilterButton
                    key={columnId}
                    label={columnsMap[columnId].header}
                    columnFilterState={filterState.columns[columnId]}
                    columnFilterOptions={filterOptions[columnId]}
                    filterConfig={columnsMap[columnId].filter}
                    columnId={columnId}
                    setColumnFilterInvisible={setColumnFilterInvisible}
                    updateColumnFilter={updateColumnFilter}
                    filterClassName={filterClassName}
                />
            })}
        </div>
        <AddFilterPopover
            setColumnFilterVisible={setColumnFilterVisible}
            unfilteredColumns={unfilteredColumns}
        />
        {filterState?.count > 0 && <Button variant="text" className={styles.reset} onClick={resetFilters}>Reset</Button>}
    </div>
})
